// Currencies Dictionary
// This dictionary contains the currencies currently available in the application
// Based on the active currencies in ExternalBookingsConfirmationModal.dictionary.ts
// and ExternalBookingsModal.dictionary.ts

export interface CurrencyOption {
  value: string
  label: string
}

export const currencies: CurrencyOption[] = [
  { value: 'USD', label: 'USD' },
  { value: 'CAD', label: 'CAD' }
]

// Helper function to get currency options for Select components
export const getCurrencyOptions = (): CurrencyOption[] => {
  return currencies
}

// Helper function to get currency value by code
export const getCurrencyByCode = (code: string): CurrencyOption | undefined => {
  return currencies.find((currency) => currency.value === code)
}

// Default currency
export const DEFAULT_CURRENCY = 'USD'
